/* SF-12 · «Tu salud física y ánimo».
   CLONADO de FisioVisión (prototipo/paciente.html · pintarSF12, del
   13-ago-2026). Se han tocado SOLO las dos cosas que permite la norma:
     · de dónde entran los datos → llegan por parámetro, no de una global
     · dónde se pinta            → devuelve el HTML, no escribe en el DOM
   Ni una medida, ni un color, ni una palabra. Ver NORMA_CLONAR_NO_INVENTAR.md.

   POR QUÉ SON DOS MARCADORES Y NO UNO (Ann): la salud FÍSICA y el ÁNIMO van
   juntos en la misma tarjeta porque el sentido está en verlos A LA VEZ — se
   puede estar mejor de la espalda y peor de ánimo, y el fisio tiene que verlo
   de un vistazo. Los dos sobre 100, con la media de la población en 50: sin
   ese 50 un «46» no dice nada. */

/* las dos fechas, tal cual del prototipo */
function fmtFechaVAS(iso){
  try{ return new Date(iso).toLocaleDateString('es-ES', { day:'2-digit', month:'short', year:'2-digit' }); }
  catch(e){ return iso; }
}
function fechaCorta(iso){
  try{ return new Date(String(iso).slice(0,10)+'T00:00:00').toLocaleDateString('es-ES',{day:'numeric',month:'long'}); }
  catch(e){ return iso; }
}

/* En el prototipo la fisio se llamaba siempre Thais. Aquí es la de VERDAD.
   Si no la sabemos, «tu fisio» — nunca un nombre inventado. */
function NOMBRE(f){ return (f && f.nombre) ? String(f.nombre).split(' ')[0] : 'Tu fisio'; }

var MEDIA = 50;   /* la media de la población · referencia oficial de la escala */

export default function sf12HTML(SF12_HIST, CUEST_CITA, FISIO){
  var h = (SF12_HIST || []).slice().sort(function(a,b){ return new Date(a.fecha)-new Date(b.fecha); });
  if(!h.length) return '';
  var hoy = h[h.length-1], ini = h[0];
  var dF = hoy.fisica - ini.fisica, dA = hoy.animo - ini.animo;
  var subiendo = (dF + dA) > 0;

  function signo(d){ return (d>0?'+':'') + Math.round(d); }
  function flecha(d){
    return d===0 ? '' :
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" '+
      'stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">'+
      (d>0 ? '<path d="M12 19V5M6 11l6-6 6 6"/>' : '<path d="M12 5v14M6 13l6 6 6-6"/>')+'</svg>';
  }
  function medidor(cl, ico, tit, val, delta, pie){
    return '<div class="fv-sf__medio es-'+cl+'">'+
      '<div class="fv-sf__medio-cab">'+
        '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">'+ico+'</svg>'+
        '<b>'+tit+'</b>'+
      '</div>'+
      '<div class="fv-sf__cifra">'+Math.round(val)+'<i>/100</i></div>'+
      '<div class="fv-sf__delta '+(delta>0?'es-sube':delta<0?'es-baja':'')+'">'+
        flecha(delta)+signo(delta)+' desde que empezaste</div>'+
      '<div class="fv-sf__barra">'+
        '<i style="width:'+Math.max(0,Math.min(100,val))+'%"></i>'+
        '<u style="left:'+MEDIA+'%" title="Media de la población"></u>'+
      '</div>'+
      '<small>'+pie+'</small>'+
    '</div>';
  }

  /* LA GRÁFICA · dos líneas. La de ánimo va a rayas, no de otro color a
     secas: quien no distingue bien los colores igual ve cuál es cuál. */
  var W=760, H=230, ML=34, MR=14, MT=14, MB=30;
  var an=W-ML-MR, al=H-MT-MB;
  var todos = h.map(function(p){ return p.fisica; }).concat(h.map(function(p){ return p.animo; }));
  var lo = Math.floor((Math.min.apply(null,todos)-4)/5)*5;
  var hi = Math.ceil((Math.max.apply(null,todos)+4)/5)*5;
  var x = function(i){ return ML + (h.length===1 ? an/2 : an*i/(h.length-1)); };
  var y = function(v){ return MT + al*(1-(v-lo)/(hi-lo)); };

  var rejilla='', paso=(hi-lo)/5;
  for(var g=0; g<=5; g++){
    var v = lo + paso*g;
    rejilla += '<line x1="'+ML+'" y1="'+y(v).toFixed(1)+'" x2="'+(W-MR)+'" y2="'+y(v).toFixed(1)+'" class="fv-sf__g"/>'+
      '<text x="'+(ML-8)+'" y="'+(y(v)+4).toFixed(1)+'" class="fv-sf__gtxt">'+Math.round(v)+'</text>';
  }
  function linea(k){ return h.map(function(p,i){ return (i?'L':'M')+x(i).toFixed(1)+' '+y(p[k]).toFixed(1); }).join(' '); }
  function puntos(k,cl){ return h.map(function(p,i){
    return '<circle cx="'+x(i).toFixed(1)+'" cy="'+y(p[k]).toFixed(1)+'" r="4.2" class="'+cl+'"/>'; }).join(''); }
  var fechas = h.map(function(p,i){
    return '<text x="'+x(i).toFixed(1)+'" y="'+(H-8)+'" class="fv-sf__fecha" text-anchor="'+
      (i===0?'start':i===h.length-1?'end':'middle')+'">'+fmtFechaVAS(p.fecha)+'</text>'; }).join('');

  return (
    '<div class="fv-sf">'+
      '<div class="fv-sf__cab">'+
        '<div><h3>Tu salud física y ánimo</h3>'+
          '<small>SF-12 · respondido el '+fechaCorta(hoy.fecha)+'</small></div>'+
        (h.length>1 ? '<span class="fv-sf__etq '+(subiendo?'es-sube':'')+'">'+
           (subiendo?'Mejorando':'Se mantiene')+'</span>' : '')+
      '</div>'+

      '<div class="fv-sf__medios">'+
        medidor('fisica','<path d="M3 9v6M6 7v10M18 7v10M21 9v6M6 12h12"/>','Tu forma física',
                hoy.fisica, dF, 'La marca es la media de la población ('+MEDIA+')')+
        medidor('animo','<circle cx="12" cy="12" r="9"/><path d="M8.5 14.5c.9 1.2 2.1 1.8 3.5 1.8s2.6-.6 3.5-1.8"/><path d="M9 9.5h.01M15 9.5h.01"/>','Tu ánimo',
                hoy.animo, dA,
                hoy.animo >= MEDIA ? 'Por encima de la media' : 'La marca es la media de la población ('+MEDIA+')')+
      '</div>'+

      (h.length>1
        ? '<div class="fv-sf__evo">'+
            '<span class="crm-portal-enunciado es-oscuro">Tu evolución</span>'+
            '<div class="fv-sf__leyenda">'+
              '<span><i class="es-fisica"></i>Forma física</span>'+
              '<span><i class="es-animo"></i>Ánimo</span>'+
            '</div>'+
            '<svg viewBox="0 0 '+W+' '+H+'" class="fv-sf__svg" preserveAspectRatio="xMidYMid meet">'+
              rejilla+
              '<path d="'+linea('fisica')+'" class="fv-sf__l es-fisica"/>'+
              '<path d="'+linea('animo')+'" class="fv-sf__l es-animo"/>'+
              puntos('fisica','es-pf')+puntos('animo','es-pa')+
              fechas+
            '</svg>'+
          '</div>'
        : '')+

      '<div class="fv-sf__nota">'+
        '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M21 12a8 8 0 01-8 8H4l2-3a8 8 0 1115-5z"/></svg>'+
        '<p>'+(subiendo
          ? 'Tu forma física sube visita a visita y tu ánimo ya está por encima de la media.'
          : (NOMBRE(FISIO)+' lo mira y lo tiene en cuenta para lo que viene.'))+
          (CUEST_CITA
            ? ' '+NOMBRE(FISIO)+' lo verá antes de tu sesión del <b>'+CUEST_CITA.texto+'</b>.' : '')+'</p>'+
      '</div>'+
    '</div>');
}
